export var CHIP_SIZES = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};
export var isValidChipSize = function (size) {
    return Object.values(CHIP_SIZES).includes(size);
};
export var CHIP_VARIANTS = {
    PILL: 'pill',
    CHIP: 'badge',
    TAG: 'tag',
};
export var isValidChipVariant = function (variant) {
    return Object.values(CHIP_VARIANTS).includes(variant);
};
export var CHIP_TYPES = {
    DEFAULT: 'default',
    LEADING: 'leading',
    TRAILING: 'trailing',
    ONLY: 'only',
};
export var isValidChipType = function (type) {
    return Object.values(CHIP_TYPES).includes(type);
};
